






























import { Component, Vue } from 'vue-property-decorator';
import { ISenderCreate } from '@/interfaces';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { dispatchCreateSender, dispatchGetPriorities, readPriorities } from '@/store/admin/accessors';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
  },
})
export default class CreateSender extends Vue {
  public valid = false;
  public name: string = '';
  public blockInternational: boolean = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    this.reset();
  }

  public reset() {
    this.name = '';
    this.blockInternational = false;
    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const updateSender: ISenderCreate = {
        name: this.name,
        block_international: this.blockInternational,
      };
      const result = await dispatchCreateSender(this.$store, updateSender);
      if (result) {
        await this.$router.push('/main/admin/senders');
      }
    }
  }
}
